<template>
  <div>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn class="mx-2" fab x-small color="primary" @click="$router.back()">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Agreement
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="product"
                outlined
                v-model="form.product_id"
                :items="productsItems"
                label="Property Type *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.product_id"
              />
            </v-col>
            <v-col sm="8">
              <input
                type="file"
                id="image_paths"
                name="image_paths"
                ref="image_paths"
                accept="image/*"
                multiple
                @change="handleFileChange"
              />
              <v-btn
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="removeImages"
              >
                Remove All
              </v-btn>
              <div v-if="previewImages.length" class="mt-2">
                <div v-for="(img, index) in previewImages" :key="index" class="d-inline-block mr-2">
                  <v-img :src="img" width="100" height="100" contain></v-img>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading || !form.product_id || !selectedFiles.length"
            @click="save"
          >
            Save Agreement
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProductAgreementCreatePage",
  data() {
    return {
      form: {
        product_id: "",
      },
      productsItems: [],
      isLoading: false,
      selectedFiles: [],
      previewImages: [],
      error_msg: "",
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      try {
        const response = await axios.get("masters?context=product");
        if (response.data?.product) {
          this.productsItems = response.data.product.map((product) => ({
            text: product.product_name,
            value: product.id,
          }));
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    },

    handleFileChange(event) {
      this.selectedFiles = Array.from(event.target.files);
      this.previewImages = [];
      this.selectedFiles.forEach(file => {
        const reader = new FileReader();
        reader.onload = (e) => this.previewImages.push(e.target.result);
        reader.readAsDataURL(file);
      });
    },

    removeImages() {
      this.$refs.image_paths.value = null;
      this.selectedFiles = [];
      this.previewImages = [];
    },

    async save() {
      if (!this.form.product_id) {
        this.error_msg = "Please select a product";
        return;
      }

      if (!this.selectedFiles.length) {
        this.error_msg = "Please upload at least one image";
        return;
      }

      this.isLoading = true;
      this.error_msg = "";

      const formData = new FormData();
      formData.append("product_id", this.form.product_id);
      
      this.selectedFiles.forEach(file => {
        formData.append("image_path[]", file);
      });

      try {
        const response = await axios.post(
          "productagreement/upload_image_path",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.success) {
          this.$router.push("/product-agreements");
        } else {
          this.error_msg = response.data.message || "Upload failed";
        }
      } catch (error) {
        console.error("Error uploading images:", error);
        this.error_msg = error.response?.data?.message || "Error uploading images";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>